import { render, staticRenderFns } from "./RequestAttachments.vue?vue&type=template&id=36c9203f&"
import script from "./RequestAttachments.vue?vue&type=script&lang=js&"
export * from "./RequestAttachments.vue?vue&type=script&lang=js&"
import style0 from "./RequestAttachments.vue?vue&type=style&index=0&id=36c9203f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports